const swiperInstance = new Swiper('[data-reccomendation-swiper]', {
    loop: false,
    slidesPerView: 2.369,
    slidesPerGroup: 1,
    spaceBetween: 10,
    breakpoints: {
      940: {
        spaceBetween: 20,
        slidesPerView: 2,
      },
      1024: {
        spaceBetween: 20,
        slidesPerView: 6,
      },
    },
    // Navigation arrows
    navigation: {
      nextEl: '[data-you-may-like-swiper-button-next]',
      prevEl: '[data-you-may-like-swiper-button-prev]',
    },
  });
  